<template>
  <div class="card">
    <div class="p-6">
      <h3 class="text-lg font-semibold text-gray-900 mb-4">评估信息</h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
        <!-- 评估类型 -->
        <div class="flex items-start gap-2">
          <span class="text-gray-500">评估类型:</span>
          <span class="font-medium text-gray-900">
            {{ assessmentTypeText }}
          </span>
        </div>
        
        <!-- 完成时间 -->
        <div class="flex items-start gap-2">
          <span class="text-gray-500">完成时间:</span>
          <span class="font-medium text-gray-900">
            {{ completionTime }}
          </span>
        </div>
        
        <!-- 回答题数 -->
        <div class="flex items-start gap-2">
          <span class="text-gray-500">回答题数:</span>
          <span class="font-medium text-gray-900">
            {{ totalQuestions }} 题
          </span>
        </div>
        
        <!-- 会话ID -->
        <div class="flex items-start gap-2">
          <span class="text-gray-500">会话ID:</span>
          <span class="font-mono text-xs text-gray-700">
            {{ sessionId }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssessmentInfo',
  props: {
    assessmentType: {
      type: String,
      default: 'self'
    },
    endTime: {
      type: String,
      default: null
    },
    responsesCount: {
      type: Number,
      default: 0
    },
    sessionId: {
      type: String,
      default: ''
    }
  },
  computed: {
    assessmentTypeText() {
      return this.assessmentType === 'self' ? '给自己测' : '为恋人测'
    },
    completionTime() {
      if (!this.endTime) {
        return '未知'
      }
      try {
        return new Date(this.endTime).toLocaleString('zh-CN')
      } catch (e) {
        return '未知'
      }
    },
    totalQuestions() {
      return this.responsesCount
    }
  }
}
</script>

<style scoped>
/* 样式已经在全局CSS中定义 */
</style>

